import React, { useEffect } from "react";
import "./PolicyPages.css";
import { Helmet } from "react-helmet-async";
function Security() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    
    <div className="page container">

       <Helmet>
        <title>McAfee Security | realgeneric shop</title>
        <meta
          name="description"
          content="Learn how Realgenericshop uses McAfee Protection to secure your online shopping and payment information."
        />
        <link rel="canonical" href="https://realgenericshop.com/security" />
                  
      </Helmet>

      <h1>McAfee Protection – Safe & Secure Online Shopping</h1>

      <p>
        McAfee is a trusted global cybersecurity provider that safeguards your online activity.
        With McAfee Protection, <b>Realgenericshop</b> ensures your personal and payment information
        stays private while you shop for medicines online.
      </p>

      <p>
        We also conduct regular security audits to keep our systems updated, and security badges
        are always visible at checkout so you can shop confidently. Your data is never shared or sold
        to third parties.
      </p>

      <h3>Why Do We Use McAfee?</h3>

      <p>Your safety is our priority. Along with offering healthcare essentials at affordable prices, we ensure:</p>

      <ul>
        <li>Protect your credit card and personal data during checkout</li>
        <li>Block phishing, malware, and unsafe websites</li>
        <li>Maintain confidentiality in discreet purchases</li>
        <li>Provide real-time monitoring and alerts</li>
        <li>Build trust for safe, worry-free shopping</li>
      </ul>

      <h3>How McAfee Works</h3>

      <p>
        McAfee Protection secures your transactions using encryption and real-time threat detection.
        It prevents unauthorized access and blocks malicious activities like malware, trojans,
        and unwanted programs so you can browse and purchase medicines confidently.
      </p>

      <h3>Customer Privacy & Security Guaranteed</h3>

      <p>
        With McAfee Protection, every purchase on <b>Realgenericshop</b> is encrypted and verified.
        Whether ordering for general wellness or specific treatments, your health and privacy remain protected.
      </p>

      <h3>FAQs</h3>

      <h4>What is McAfee Protection?</h4>
      <p>
        McAfee Protection is a cybersecurity service that helps secure your online activity.
        It protects your data and transactions while shopping online.
      </p>

      <h4>Is my payment information safe?</h4>
      <p>
        Yes. With McAfee’s advanced firewalls and encryption, your credit card and personal details
        remain secure during every transaction.
      </p>

      <h4>Why is security important in online pharmacies?</h4>
      <p>
        Since buying medicines online involves sharing personal health and payment information,
        security features like McAfee Protection ensure your medical and financial details remain confidential.
      </p>

    </div>
  );
}

export default Security;